import Icon from '@material-ui/core/Icon';
import IconButton from '@material-ui/core/IconButton';
import withWidth from '@material-ui/core/withWidth';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import React, { Fragment } from 'react';
import { withRouter } from 'react-router-dom';
import Breadcrumbs from '@material-ui/core/Breadcrumbs';
import Link from '@material-ui/core/Link';
import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import { getEnvVariable } from '../../../modules/environmentalList';
import { NavigateNext } from '@material-ui/icons';
import { Fab } from '@material-ui/core';
import { useSelector } from 'react-redux';

const useStyles = makeStyles((theme) => ({
    link: {
        display: 'flex',
    },
    icon: {
        //marginRight: theme.spacing(0.5),
        width: 25,
        height: 22,
        paddingTop: 4

    },
}));

const useStyleLink = makeStyles((theme) => ({
    link: {
        display: 'flex',
        color: '#00355f',
    },
    icon: {
        display: 'flex',
        justifyContent: 'center',
        paddingBottom: 3,
        width: 25,

    }
}));
// function getLocalStorageValue() {
//     const value = localStorage.getItem('menulistview'|| 'Y');
//     return value ? JSON.parse(value) : null;
//   }

function BreadCrumbs(props) {
    const isTabView = useSelector(state => state.header && state.header.movebartoTop ? state.header.movebartoTop :
        localStorage.getItem('menulistview') || 'Y')
    const CSSColorClasses = (style = '') => {
        let module = getEnvVariable('ModuleKey');
        console.log("module", module)
        switch (module) {
            case 'LAOACS':
                return '#00355f !important'
            case 'WRS':
                return '#0076A5'
            case 'FORWARD':
                return '#074078'
            case 'AEPS':
                return '#00355f !important'
            case 'UPS':
                return '#337ab7'
            // case 'AMES':
            //     return 'rgb(41,51,82) !important'
            default:
                return '#00355f';
        }
    }

    const classes = useStyles();
    const classes2 = useStyleLink();
    return <Breadcrumbs separator={<NavigateNext fontSize="small" />} aria-label="breadcrumb" className={props.className + ' ' || ''} style={{ padding: '0px' }}>
        {props.items && props.items.map((e, i) => {
            if (!e.ishide) {
                if (e.tab)
                    localStorage.setItem('tab', e.tab);
                let path = ''
                if (e.href && e.href.routes) {
                    if (Array.isArray(e.href.routes)) {
                        e.href.routes.forEach(each => {
                            const { route, routeParams, matchProps } = each
                            if (routeParams) {
                                path += route + "/" + props.match.params[routeParams]
                            }
                            else if (matchProps) {
                                path += route + "/" + props.results && props.results[matchProps]
                            }
                            else {
                                path += route
                            }
                        })
                    }
                }
                return (e.href && (isTabView === 'N' || !isTabView)) ? <Link href={path !== '' ? path : e.href} className={classes.link + e.className} style={{ color: e.color ? CSSColorClasses() : '' }}         >
                    {e.materialicon && <Icon size='small' className={classes.icon} style={{ fontSize: e.fontSize || '20px' }} >{e.materialicon}</Icon>}
                    {e.link} {
                        props.moreicon && <IconButton aria-haspopup="true" onClick={props.handleBreadcrumbMenu} size='small'>
                            <ExpandMoreIcon className={classes.icon} style={{ color: e.color ? e.color : CSSColorClasses() }} />
                        </IconButton>
                    }
                </Link> :
                    (e.tab) ? '' : <Typography className={classes2.link} style={{ margin: '2px', color: (isTabView === 'Y') ? e.color ? e.color : 'black' : (e.class === 'text-light') ? CSSColorClasses() : (e.color ? e.color : CSSColorClasses()) }}>
                        {e.materialicon && <Icon size='small' className={classes2.icon} style={{ fontSize: e.fontSize || '20px' }}>{e.materialicon}</Icon>}
                        {e.link}
                    </Typography>


            }

        })}
    </Breadcrumbs >

}

export default withWidth()(withRouter(BreadCrumbs));